// extracted by mini-css-extract-plugin
export default {"MONTH":"ezDtO4","month":"ezDtO4","DAY":"Hb5vkc","day":"Hb5vkc","YEAR":"pBOSyv","year":"pBOSyv","fields":"GCihy9","mobile":"xF3C5N"};